import React from 'react';
import { useSelector } from 'react-redux';

import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { SMS_IDENTITY_PROVIDER } from '@src/constants';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useLocation from '@src/hooks/useLocation';
import Packages from '../Packages';

import { StyledBuyPackage } from './index.style';
import NewPackages from '../PackagesNew';
import NewPricingModel from '../NewPricingModel';
import SMSPackages from '../PackagesNew/PackageSMS';
import NewPricingModelV3 from '../NewPricingModelV3';

const BuyPackage = () => {
  const { getFeatureValue } = useFeatureFlags();
  const showNewPackages = getFeatureValue(FEATURE_KEYS.NEW_PAYMENT_PACKAGES);
  const { ip } = useLocation();
  const showNewPackagePriceUI = getFeatureValue(
    FEATURE_KEYS.NEW_PRICING_MODEL,
    {
      ip,
    },
  );

  const showNewPackagePriceUIV3 = getFeatureValue(
    FEATURE_KEYS.NEW_PRICING_MODEL_V3,
    { ip },
  );

  const { identityProvider } = useSelector((state) => state.auth.user);
  const isSMSUser = Object.values(SMS_IDENTITY_PROVIDER).includes(
    identityProvider,
  );
  const renderScreenPackage = () => {
    if (!isSMSUser && showNewPackages && showNewPackagePriceUIV3) {
      return <NewPricingModelV3 />;
    }
    if (!isSMSUser && showNewPackages && showNewPackagePriceUI) {
      return <NewPricingModel />;
    }

    if (!isSMSUser && showNewPackages && !showNewPackagePriceUI) {
      return <NewPackages />;
    }

    if (isSMSUser && showNewPackages) {
      return <SMSPackages />;
    }

    if (isSMSUser && !showNewPackages) {
      return <></>;
    }

    return <Packages />;
  };
  return <StyledBuyPackage>{renderScreenPackage()}</StyledBuyPackage>;
};

export default BuyPackage;
